import { render, staticRenderFns } from "./NbMultipleTables.vue?vue&type=template&id=0d3928a7&scoped=true&"
import script from "./NbMultipleTables.vue?vue&type=script&lang=js&"
export * from "./NbMultipleTables.vue?vue&type=script&lang=js&"
import style0 from "./NbMultipleTables.vue?vue&type=style&index=0&id=0d3928a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3928a7",
  null
  
)

export default component.exports